import { useRef, useEffect } from "react";
import { Container, Box } from "@mui/material";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

import tiger1 from "../../assets/gallery/tgr1.png";
import tiger2 from "../../assets/gallery/tgr2.png";
import tiger3 from "../../assets/gallery/tgr3.png";
import tiger4 from "../../assets/gallery/tgr4.png";
import tiger5 from "../../assets/gallery/tgr5.png";
import tiger6 from "../../assets/gallery/tgr6.png";
import tiger7 from "../../assets/gallery/tgr7.png";
import tiger8 from "../../assets/gallery/tgr8.png";
import tiger9 from "../../assets/gallery/tgr9.png";
import tiger10 from "../../assets/gallery/tgr10.png";
import tiger11 from "../../assets/gallery/tgr11.png";
import tiger12 from "../../assets/gallery/tgr12.png";
import tiger13 from "../../assets/gallery/tgr13.png";
import tiger14 from "../../assets/gallery/tgr14.png";

gsap.registerPlugin(ScrollTrigger);

const GallerySection = () => {
  const gallerySectionRef = useRef<HTMLDivElement | null>(null);
  const firstRowRef = useRef<HTMLDivElement | null>(null);
  const secondRowRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const element = gallerySectionRef.current;
    if (element) {
      const firstRow = firstRowRef.current;
      if (firstRow) {
        gsap.to(firstRow, {
          xPercent: 100,
          scrollTrigger: {
            trigger: element,
            start: "top center",
            end: "bottom top",
            scrub: true,
          },
        });
      }

      const secondRow = secondRowRef.current;
      if (secondRow) {
        gsap.to(secondRow, {
          xPercent: -100,
          scrollTrigger: {
            trigger: element,
            start: "top center",
            end: "bottom top",
            scrub: true,
          },
        });
      }
    }
  }, []);

  return (
    <section id="gallery" ref={gallerySectionRef}>
      <Container>
        <Box>
          <div
            className="gallery-container"
            id="gallery-row1"
            style={{ transform: "translateX(-1400px)" }}
            ref={firstRowRef}
          >
            <img src={tiger1} alt="tiger1" className="gallery-img"></img>
            <img src={tiger2} alt="tiger2" className="gallery-img"></img>
            <img src={tiger3} alt="tiger3" className="gallery-img"></img>
            <img src={tiger4} alt="tiger4" className="gallery-img"></img>
            <img src={tiger5} alt="tiger5" className="gallery-img"></img>
            <img src={tiger6} alt="tiger6" className="gallery-img"></img>
            <img src={tiger7} alt="tiger7" className="gallery-img"></img>
            <img src={tiger8} alt="tiger8" className="gallery-img"></img>
          </div>

          <div
            className="gallery-container"
            id="gallery-row2"
            style={{ transform: "translateX(-200px)" }}
            ref={secondRowRef}
          >
            <img src={tiger8} alt="tiger8" className="gallery-img"></img>
            <img src={tiger9} alt="tiger9" className="gallery-img"></img>
            <img src={tiger10} alt="tiger10" className="gallery-img"></img>
            <img src={tiger11} alt="tiger11" className="gallery-img"></img>
            <img src={tiger12} alt="tiger12" className="gallery-img"></img>
            <img src={tiger13} alt="tiger13" className="gallery-img"></img>
            <img src={tiger14} alt="tiger14" className="gallery-img"></img>
            <img src={tiger1} alt="tiger1" className="gallery-img"></img>
          </div>
        </Box>
      </Container>
    </section>
  );
};

export default GallerySection;
